export default "__VITE_ASSET__D2adZH_E__"